// State Key
export const KEY = 'settings';

// Action Types
export const types = {
  SET_CONFIGURATION_ID: `${KEY}/SET_CONFIGURATION_ID`,
  SET_CLIENT_INTEGRATION_ID: `${KEY}/SET_CLIENT_INTEGRATION_ID`
};

export interface SettingsState {
  readonly configurationId: string;
  readonly clientIntegrationId: string;
}

export interface SetConfigurationId {
  type: typeof types.SET_CONFIGURATION_ID;
  payload: string;
}

export interface SetClientIntegrationId {
  type: typeof types.SET_CLIENT_INTEGRATION_ID;
  payload: string;
}

export type SettingsActionTypes = SetConfigurationId | SetClientIntegrationId;
